import React from 'react'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useHistory } from "react-router-dom";

export default function P402Search({ setSearchWord, searchWord, submitForm }) {

    const history = useHistory();

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setSearchWord(val);
    };

    return (
        <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-4">
                <label>คำค้นหา</label>
                <InputText
                    type="text" placeholder="คำค้นหา" value={searchWord}
                    onChange={(e) => onInputTextChange(e, "searchWord")}

                />
            </div>
            <div className="p-field p-col-12 p-md-4">
                <div style={{ display: 'flex',marginTop: '8px',marginBottom : '10px' }} >
                    <Button
                        className="p-button btn-srh-responsive"
                        icon="pi pi-search"
                        label="ค้นหา"
                        style={{ marginTop: 25 }}
                        onClick={() => submitForm(searchWord)} 
                    />

                    <Button
                        className="p-button-secondary p-button btn-long-responsive"
                        icon ="pi pi-arrow-left"
                        label="กลับหน้าจอหลัก"
                        style={{  marginLeft: '5px', marginTop: 25  }}
                        onClick={() => { history.push('/400') }} 
                    />
                </div>
            </div>
        </div>
    )
}
